import { loadable } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { doAdminQueries, IQueryInfo } from '../providers/mutations'

type GradeLevelType = {
  id: number
  name: string
  ordinality: number
}

export const gradeLevelsAtom = loadable(
  atom(async () => {
    const queryInfo: IQueryInfo = {
      resourceData: {
        key: 'gradeLevels',
        fields: ['id', 'name', 'ordinality'],
      },
    }
    const response = await doAdminQueries<GradeLevelType[]>([queryInfo])
    return response.data.gradeLevels
  }),
)

export const gradesByIdAtom = atom((get) => {
  const resp = get(gradeLevelsAtom)
  if (resp.state === 'hasData') {
    return resp.data.reduce<Record<number, GradeLevelType>>((acc, grade) => {
      return {
        ...acc,
        [grade.id]: grade,
      }
    }, {})
  }
  return {}
})
